import {MomentRange} from '../../../selectors/time'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

export const usePeakLoadWindowsQuery = (
  timeFrame: MomentRange,
  {enabled, throwOnError}: {enabled?: boolean; throwOnError?: boolean} = {}
) => {
  const plantCode = useUrlParam('plantCode')
  const [from, to] = timeFrame
  return usePlannerQuery(
    'peakLoadWindows',
    [{plantCode, from: from.toISOString(), to: to.toISOString()}],
    {throwOnError: throwOnError ?? true, enabled: enabled ?? true}
  )
}
